import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { userSegmentationRoute } from '@atlassian/jira-router-routes-user-segmentation-routes/src/userSegmentationRoute.tsx';
import { UserSegmentation, LazyUserSegmentation } from './ui/index.tsx';

export const userSegmentationRouteEntry = createEntry(userSegmentationRoute, () => ({
	ufoName: 'user-segmentation',
	component: UserSegmentation,
	layout: chromelessLayout,
	forPaint: [LazyUserSegmentation],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-user-segmentation-entries/src/userSegmentationRouteEntry.tsx',
			whichExportToUse: 'userSegmentationRouteEntry',
		},

		enabled: true,
	},
}));
